var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 32h-32l0.22-1.080c0-0.42 1.040-8.8 7.36-13.1l0.64-0.42 0.62 0.42c1.924 1.709 4.472 2.753 7.264 2.753 2.695 0 5.163-0.973 7.072-2.587l-0.016 0.013 0.62-0.42 0.64 0.42c6.52 4.3 7.36 12.68 7.36 13.1zM2.32 29.86h27.16c-0.779-3.967-2.82-7.364-5.678-9.842l-0.022-0.018c-2.184 1.602-4.925 2.564-7.89 2.564s-5.706-0.962-7.928-2.591l0.038 0.026c-2.797 2.554-4.809 5.926-5.657 9.736l-0.023 0.124zM16 0c-4.982 0-9.020 4.038-9.020 9.020s4.038 9.020 9.020 9.020c4.982 0 9.020-4.038 9.020-9.020v0c0-4.982-4.038-9.020-9.020-9.020v0zM16 15.88c-0.006 0-0.013 0-0.020 0-3.8 0-6.88-3.080-6.88-6.88s3.080-6.88 6.88-6.88c3.8 0 6.88 3.080 6.88 6.88 0 0.007 0 0.014-0 0.021v-0.001c-0.011 3.784-3.076 6.849-6.859 6.86h-0.001z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.ba08f7cad56f2557f28e7f79e2b58b36.svg";
export { ForwardRef as ReactComponent };